import type { BooleanItemFilterKeys } from '@/lib/api/types/itemFilters';

export const ITEM_BOOLEAN_FILTERS = [
  'isUnparented',
] as const satisfies readonly BooleanItemFilterKeys[];
export type ItemBooleanFilterKey = (typeof ITEM_BOOLEAN_FILTERS)[number];
